import axios from "axios";
import {APP_URL} from "../constants/constants";

export default class ErrorApi {
  static send(body) {
     axios.post(
      `${APP_URL}/api/send-error-boundary`, body, {
        validateStatus: status => status < 500
      }
    );
  }
}